const ON_CHANGE_DEBOUNCE_TIMER_CART = 300;

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

// Remove Line From Cart
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0, this.dataset.remove);

      const res = await fetch('/cart.js');
      const data = res.json();
      this.dispatchEvent(
        new CustomEvent('on:cart:update', {
          bubbles: true,
          detail: {
            cart: data,
          },
        })
      );
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

// Cart Items functionality
class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.bindEventListeners();

    document.addEventListener('on:cart:add', (e) => {
      this.onCartUpdate();
    });

    // addB2BLineprices(this);
    // setTimeout(() => {
    //   addB2BLineprices(this);
    //   calculateTotals();
    // }, 1000);

    const noteTextarea = this.querySelector('.cart__comment--textarea');
    if (noteTextarea) {
      noteTextarea.addEventListener('change', () => this.updateNote());
    }
  }

  bindEventListeners() {
    const quantityInputs = this.querySelectorAll('cart-item input[name="quantity"]');
    quantityInputs.forEach((input) => input.addEventListener('change', (event) => this.handleQuantityChange(event)));
  }

  updateNote() {
    const note = this.querySelector('.cart__comment--textarea').value;

    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({ note }),
    })
      .then((response) => response.json())
      .then((state) => {
        console.log('Cart note updated:', state);
        this.onCartUpdate();
      })
      .catch((error) => {
        console.error('Error updating cart note:', error);
      });
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?sections=main-cart,section-side-cart`)
      .then((response) => response.json())
      .then((data) => {
        const mainCart = new DOMParser().parseFromString(data['main-cart'], 'text/html');
        const sideCart = new DOMParser().parseFromString(data['section-side-cart'], 'text/html');
        const updatedCartItems = mainCart.querySelector('#main-cart-items');

        if (updatedCartItems) {
          const cartItemsContainer = document.querySelector('#main-cart-items');
          if (cartItemsContainer) {
            cartItemsContainer.innerHTML = updatedCartItems.innerHTML;
          }

          toggleResponsiveElements();

          const deliveryEstimator = document.querySelector('delivery-estimator');
          if (deliveryEstimator) {
            deliveryEstimator.calculateDeliveryDates();
          }
        }

        const updatedCartTotals = mainCart.querySelector('#cart-totals');
        const cartTotalsContainer = document.querySelector('#cart-totals');
        if (updatedCartTotals && cartTotalsContainer) {
          cartTotalsContainer.innerHTML = updatedCartTotals.innerHTML;
        }

        const updatedCartHeader = mainCart.querySelector('.cart__header');
        const cartHeaderContainer = document.querySelector('.cart__header');
        if (updatedCartHeader && cartHeaderContainer) {
          cartHeaderContainer.innerHTML = updatedCartHeader.innerHTML;
        }

        const updatedCartComments = mainCart.querySelector('.cart .cart__comments--holder');
        const cartComments = document.querySelector('.cart .cart__comments--holder');
        if (cartComments && updatedCartComments) {
          cartComments.innerHTML = updatedCartComments.innerHTML;
        }

        document.querySelectorAll('vat-calculator').forEach((calculator) => {
          calculator.dataset.totalPrice = mainCart.querySelector('#cart-totals').dataset.totalPrice;
          calculator.init();
        });

        if (sideCart) {
          document.querySelector('side-cart .side-cart__form').innerHTML =
            sideCart.querySelector('side-cart .side-cart__form').innerHTML;

          document.querySelector('side-cart .cart__comments--holder').innerHTML = sideCart.querySelector(
            'side-cart .cart__comments--holder'
          ).innerHTML;

          document.querySelector('side-cart .side-cart__totals').innerHTML =
            sideCart.querySelector('side-cart .side-cart__totals').innerHTML;
        }
        var event = new Event('change');
        document.querySelector('.btw-switch__input').dispatchEvent(event);
      })
      .finally(() => {
        this.bindEventListeners();
        // setTimeout(() => {
        //   addB2BLineprices(this);
        // }, 1000);
      })
      .catch((error) => {
        console.error('Error fetching updated cart:', error);
      });
  }

  async updateSideCart() {
    fetch('/?section_id=section-side-cart')
      .then((res) => res.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const updatedSideCart = doc.querySelector('side-cart');

        if (updatedSideCart) {
          const sideCart = document.querySelector('side-cart');

          const items = sideCart.querySelector('cart-items');
          items.innerHTML = updatedSideCart.querySelector('cart-items').innerHTML;

          const totals = sideCart.querySelector('.side-cart__totals');
          totals.innerHTML = updatedSideCart.querySelector('.side-cart__totals').innerHTML;
        }
      })
      .finally(() => {
        this.bindEventListeners();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart__products',
      },
    ];
  }

  updateQuantity(line, quantity, remove_id) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line: parseInt(line),
      quantity: parseInt(quantity),
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll('.cart__item');

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        //console.log(parsedState.items_removed);

        this.onCartUpdate();
      })
      .catch(() => {
        console.error('Error updating cart');
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems?.classList.add('cart__items--disabled');

    const cartItemElements = document.querySelectorAll(`cart-item[index="${line}"]`);

    cartItemElements.forEach((cartItemElement) => {
      cartItemElement.classList.add('is-loading');
    });
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems?.classList.remove('cart__items--disabled');

    const cartItemElements = document.querySelectorAll(`cart-item[index="${line}"]`);

    cartItemElements.forEach((cartItemElement) => {
      cartItemElement.classList.remove('is-loading');
    });
  }

  handleQuantityChange(event) {
    const input = event.target;

    if (input.name === 'quantity') {
      const cartItemElement = input.closest('cart-item');
      const line = cartItemElement?.getAttribute('index');

      clearTimeout(this.quantityChangeTimeout);

      this.quantityChangeTimeout = setTimeout(() => {
        const quantity = parseInt(input.value, 10) || 0;

        if (line && quantity >= 1) {
          console.log('Updating line item:', line, 'Quantity:', quantity);
          this.updateQuantity(line, quantity);
        }
      }, 500);
    }
  }
}

customElements.define('cart-items', CartItems);

// Delivery time estimation based on cart items
class DeliveryEstimator extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.calculateDeliveryDates();
  }

  calculateDeliveryDates() {
    // Default delivery range if none is provided
    const defaultRange = { min: 1, max: 5 };
    let maxDelivery = null;

    const addWorkingDays = (date, days) => {
      let count = 0;
      const result = new Date(date);

      while (count < days) {
        result.setDate(result.getDate() + 1);
        const dayOfWeek = result.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          // Exclude Sunday (0) and Saturday (6)
          count++;
        }
      }

      return result;
    };

    const cartItems = Array.from(document.querySelectorAll('cart-item'));

    cartItems.forEach((item) => {
      const deliveryTime = item.getAttribute('data-delivery');

      if (deliveryTime) {
        const match = deliveryTime.match(/(\d+)(?:-(\d+))?/);

        if (match) {
          //const minDays = parseInt(match[1], 10);
          const minDays = 1;
          const maxDays = parseInt(match[2] || match[1], 10);

          if (!maxDelivery || maxDays > maxDelivery.max) {
            maxDelivery = { min: minDays, max: maxDays };
          }
        }
      }
    });

    // If no delivery dates were provided, use the default range
    if (!maxDelivery) {
      maxDelivery = { ...defaultRange };
    }

    // Calculate delivery dates based on the longest range
    const today = new Date();
    const startDate = addWorkingDays(today, maxDelivery.min);
    const endDate = addWorkingDays(today, maxDelivery.max);

    const formatDate = (date) => date.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' });

    const deliveryContent = this.querySelector('.delivery__content');
    if (deliveryContent) {
      deliveryContent.textContent = `Je bestelling wordt tussen ${formatDate(startDate)} en ${formatDate(
        endDate
      )} geleverd.`;
    }
  }
}

// Define the custom element
customElements.define('delivery-estimator', DeliveryEstimator);

// VAT calculator
class VatCalculator extends HTMLElement {
  constructor() {
    super();
    this.totalPrice = parseFloat(this.dataset.totalPrice) || 0;
    this.vatPercentage = parseFloat(this.dataset.vatPercentage) || 0;

    this.endTotalElement = this.querySelector('.cart__totals__row--value__end-total');
    this.vatTotalElement = this.querySelector('.cart__totals__row--value__vat-total');

    this.init();
  }

  init() {
    this.totalPrice = parseFloat(this.dataset.totalPrice) || 0;
    this.vatPercentage = parseFloat(this.dataset.vatPercentage) || 0;
    if (!this.endTotalElement || !this.vatTotalElement) {
      console.error('Required elements not found in VatCalculator.');
      return;
    }

    const vatDivisor = 1 + this.vatPercentage / 100;
    const endTotal = this.totalPrice / vatDivisor;
    const vatTotal = this.totalPrice - endTotal;

    this.updateValues(endTotal, vatTotal);
  }

  updateValues(endTotal, vatTotal) {
    this.endTotalElement.textContent = window.Shopmonkey.formatMoney(endTotal);
    this.vatTotalElement.textContent = window.Shopmonkey.formatMoney(vatTotal);

    const finalPrice = endTotal + vatTotal;
    toggleQuoteButton(finalPrice);
  }
}

customElements.define('vat-calculator', VatCalculator);

// Shipping costs
class ShippingCosts extends HTMLElement {
  constructor() {
    super();
    // this.totalPrice = parseFloat(this.dataset.totalPrice) || 0;
    // this.vatPercentage = parseFloat(this.dataset.vatPercentage) || 0;

    // this.endTotalElement = this.querySelector('.cart__totals__row--value__end-total');
    // this.vatTotalElement = this.querySelector('.cart__totals__row--value__vat-total');

    this.init();
  }

  async init() {
    const shippingRates = await fetchShippingRates();

    const priceElement = this.querySelector('[data-shipping-price]');
    if (shippingRates.shipping_rates) {
      const price = shippingRates.shipping_rates[0].price * 100;
      priceElement.dataset.price = price;
      priceElement.dataset.totalItem = price;
      priceElement.textContent = window.Shopmonkey.formatMoney(price);
    }
    calculateTotals();
    var event = new Event('change');
    document.querySelector('.btw-switch__input').dispatchEvent(event);
  }
}

function calculateTotals() {
  const totalsElement = document.querySelectorAll('[data-cart-totals]');
  addB2BTotalprices();
  totalsElement.forEach(function (element) {
    var totalPrice = 0;
    const items = element.querySelectorAll('[data-total-item]');
    const vatCalculator = document.querySelectorAll('vat-calculator');
    items.forEach(function (item) {
      totalPrice += parseFloat(item.dataset.totalItem);
    });
    if (totalPrice) {
      document.querySelectorAll('[data-totals-total]').forEach(function (item) {
        item.textContent = window.Shopmonkey.formatMoney(totalPrice);
        item.dataset.price = totalPrice;
        vatCalculator.forEach(function (calculator) {
          calculator.dataset.totalPrice = totalPrice;
          calculator.init();
        });
      });
    }
  });
  var event = new Event('change');
  document.querySelector('.btw-switch__input').dispatchEvent(event);
}

function addB2BTotalprices() {
  var total = BSS_B2B.shopData.cart.bss_b2b_total_price;
  const subtotalElement = document.querySelectorAll('[data-total-subtotal]');
  subtotalElement.forEach(function (element) {
    element.dataset.price = total;
    element.dataset.totalItem = total;
  });
}

function addB2BLineprices(current) {
  current.querySelectorAll('[data-b2b-test-key]').forEach((cartItem) => {
    var itemKey = cartItem.dataset.b2bTestKey;
    if (!BSS_B2B.storage) {
      return false;
    }
    BSS_B2B.storage.cartStorage.store.forEach((item) => {
      if (itemKey == item.key && item.bssB2BPriceAfterQB) {
        var element = current.querySelector('[data-b2b-test-key="' + itemKey + '"]');
        element.textContent = window.Shopmonkey.formatMoney(item.bssB2BPriceAfterQB * item.quantity);
        element.dataset.price = item.bssB2BPriceAfterQB * item.quantity;
      }
    });
  });

  var event = new Event('change');
  document.querySelector('.btw-switch__input').dispatchEvent(event);

  // console.log(BSS_B2B.storage.cartStorage.store);
  // BSS_B2B.storage.cartStorage.store.forEach((item) => {
  //   if (item.bssB2BPriceAfterQB) {
  //     // elem = document.querySelector('[b2b-test-key="' + item.key + '"]');
  //     // elem.textContent = window.Shopmonkey.formatMoney(item.bssB2BPriceAfterQB * item.quantity);
  //     // console.log(item.bssB2BPriceAfterQB * item.quantity);
  //   }
  // });
}

customElements.define('shipping-costs', ShippingCosts);

async function fetchShippingRates() {
  params = {
    'shipping_address[country]': 'NL',
    'shipping_address[address1]': 'Spoordreef 1',
    'shipping_address[zip]': '4765 SP',
    'shipping_address[city]': 'Zevenbergschen Hoek',
  };

  const sleep = (m) => new Promise((r) => setTimeout(r, m));

  await prepareShippingRates();

  await sleep(500);

  // Zet het object om naar een querystring
  const baseUrl = '/cart/async_shipping_rates.json';
  const queryString = new URLSearchParams(params).toString();

  const requestOptions = {
    method: 'GET',
    // headers: {
    //   Cookie: 'secure_customer_sig=', // Voeg hier alleen noodzakelijke cookies toe
    // },
    redirect: 'follow',
  };

  try {
    const response = await fetch(`${baseUrl}?${queryString}`, requestOptions);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json(); // Wachten op JSON resultaat
    await prepareShippingRates(true);
    return data; // Geef het resultaat terug
  } catch (error) {
    return {
      shipping_rates: [
        {
          price: 0,
        },
      ],
    };
    // console.error('Fetch error:', error);
    // return 'Er gaat iets fout'; // Optioneel: null teruggeven bij een fout
  }
}

async function prepareShippingRates(reset = false) {
  // Zet het object om naar een querystring
  const baseUrl = '/cart/prepare_shipping_rates.json';
  const queryString = new URLSearchParams(params).toString();

  var shipping_address = {
    shipping_address: {
      country: 'NL',
      address1: 'Spoordreef 1',
      zip: '4765 SP',
      city: 'Zevenbergschen Hoek',
    },
  };

  if (reset) {
    shipping_address = {
      shipping_address: {
        country: 'NL',
        address1: '',
        zip: '',
        city: '',
      },
    };
  }

  const raw = JSON.stringify(shipping_address);

  const headers = {
    Accept: '*/*',
    'Content-Type': 'application/json',
    Cookie: 'secure_customer_sig=;', // Voeg hier alleen noodzakelijke cookies toe
    Origin: 'http://127.0.0.1:9292',
    Referer: 'http://127.0.0.1:9292/cart',
  };

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: raw,
    redirect: 'follow',
  };

  try {
    const response = await fetch(`${baseUrl}`, requestOptions);
    console.log(response);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json(); // Wachten op JSON resultaat
    return data; // Geef het resultaat terug
  } catch (error) {
    console.error('Fetch error:', error);
    return 'Er gaat iets fout'; // Optioneel: null teruggeven bij een fout
  }
}

// Initialize Splide carousels
function initializeCarousel(context = document) {
  const upsellCarousel = context.querySelector('.cart__upsell--products');

  if (upsellCarousel) {
    const splideUpsellProducts = new Splide(upsellCarousel, {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      arrows: true,
      pagination: false,
      gap: 20,
      breakpoints: {
        991: {
          perPage: 2,
          arrows: true,
        },
        768: {
          perPage: 2,
          arrows: true,
        },
        600: {
          perPage: 1,
          arrows: true,
        },
      },
    });

    splideUpsellProducts.mount();
  }
}

// Function to clean up Splide instances
function destroyCarousel(context = document) {
  const carousel = context.querySelectorAll('.splide');
  carousel.forEach((carousel) => {
    const instance = Splide.instances[carousel.id];
    if (instance) {
      instance.destroy(true);
    }
  });
}

// Event for Shopify Theme Editor: Section Loaded
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  initializeCarousel(section);
});

// Event for Shopify Theme Editor: Section Unloaded
document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target;
  destroyCarousel(section);
});

document.addEventListener('DOMContentLoaded', () => {
  // Initialize carousels
  initializeCarousel();
});

// Reposition responsive elements
function toggleResponsiveElements() {
  const desktopQuantityInputs = document.querySelectorAll('.js-quantity__inputs--desktop');
  const mobileQuantityInputs = document.querySelectorAll('.js-quantity__inputs--mobile');

  const desktopUpsellWrapper = document.querySelector('.cart__upsell--wrapper--desktop');
  const mobileUpsellWrapper = document.querySelector('.cart__upsell--wrapper--mobile');
  const productSlider = document.querySelector('.cart__products--slider');

  // Handle quantity inputs
  desktopQuantityInputs.forEach((desktopInput, index) => {
    const mobileInput = mobileQuantityInputs[index];

    if (window.innerWidth <= 768) {
      // Move quantity inputs to mobile container
      if (mobileInput && desktopInput.children.length > 0) {
        const quantityInput = desktopInput.children[0];
        const removeButton = mobileInput.querySelector('cart-remove-button');

        if (quantityInput && removeButton) {
          mobileInput.insertBefore(quantityInput, removeButton);
        }
      }
    } else {
      // Move quantity inputs back to desktop container
      if (desktopInput && mobileInput.children.length > 0) {
        const quantityInput = mobileInput.querySelector('.cart__product--quantity');
        if (quantityInput) {
          desktopInput.appendChild(quantityInput);
        }
      }
    }
  });

  // Handle upsell product slider
  // if (productSlider) {
  //   if (window.innerWidth <= 768) {
  //     // Move product slider to mobile wrapper
  //     if (mobileUpsellWrapper && mobileUpsellWrapper !== productSlider.parentElement) {
  //       mobileUpsellWrapper.appendChild(productSlider);
  //     }
  //   } else {
  //     // Move product slider back to desktop wrapper
  //     if (desktopUpsellWrapper && desktopUpsellWrapper !== productSlider.parentElement) {
  //       desktopUpsellWrapper.appendChild(productSlider);
  //     }
  //   }
  // }
}

// Run on page load
toggleResponsiveElements();

// Add event listener to run on window resize
window.addEventListener('resize', toggleResponsiveElements);

function toggleQuoteButton(totalPrice) {
  const quoteButton = document.querySelector('.to__quote');
  const thresholdElement = document.querySelector('#cart');

  if (!quoteButton || !thresholdElement) return;

  const threshold = parseFloat(thresholdElement.dataset.thresholdQuote);

  console.log('Total Price:', totalPrice, 'Threshold:', threshold);

  if (totalPrice >= threshold) {
    console.log('Showing Quote Button');
    quoteButton.classList.remove('d-none');
  } else {
    console.log('Hiding Quote Button');
    quoteButton.classList.add('d-none');
  }
}
